(() => {
  const initQuiz = (quiz) => {
    if (quiz.dataset.ready) return;
    quiz.dataset.ready = 'true';

    const startBtn = quiz.querySelector('[data-quiz-start]');
    const hero = quiz.querySelector('.qhero');
    const shell = quiz.querySelector('.qshell');
    const questions = [...quiz.querySelectorAll('[data-quiz-question]')];
    const next = quiz.querySelector('[data-quiz-next]');
    const back = quiz.querySelector('[data-quiz-back]');
    const controls = quiz.querySelector('[data-quiz-controls]');
    const result = quiz.querySelector('[data-quiz-result]');
    const fill = quiz.querySelector('[data-quiz-fill]');
    const progressNum = quiz.querySelector('[data-quiz-progress-num]');
    if (!questions.length || !next) return;
    let step = 0;

    const render = () => {
      questions.forEach((question, index) => { question.classList.toggle('on', index === step); });
      if (fill) fill.style.width = `${((step + 1) / questions.length) * 100}%`;
      if (progressNum) progressNum.textContent = `${step + 1} of ${questions.length}`;
      if (back) back.disabled = step === 0;
      next.disabled = !questions[step].querySelector('input:checked');
      next.textContent = step === questions.length - 1 ? 'Reveal My Match' : 'Continue';
    };

    startBtn?.addEventListener('click', () => {
      if (hero) hero.style.display = 'none';
      shell?.classList.add('on');
      shell?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      render();
    });

    quiz.addEventListener('change', render);
    back?.addEventListener('click', () => { step = Math.max(0, step - 1); render(); });
    next.addEventListener('click', () => {
      if (step < questions.length - 1) { step += 1; render(); return; }
      /* The match is decided entirely by the final question's answer (not a
         sum across all 4) — each answer there is written to point at a
         single scent, so this is a direct, predictable mapping rather than
         a blended score a shopper can't easily reason about. */
      const scores = { bequest: 0, dame: 0, velvet: 0, discovery: 0 };
      const finalAnswer = questions[questions.length - 1].querySelector('input:checked');
      Object.keys(scores).forEach((key) => { scores[key] = Number(finalAnswer?.dataset[key] || 0); });
      const availableKeys = [...result.querySelectorAll('[data-result][data-result-available]')]
        .map((item) => item.dataset.result);
      const candidates = availableKeys.length ? availableKeys : Object.keys(scores);
      const winner = candidates.sort((a, b) => scores[b] - scores[a])[0];
      shell?.classList.remove('on');
      controls.hidden = true;
      result.hidden = false;
      result.classList.add('on');
      result.querySelectorAll('[data-result]').forEach((item) => { item.hidden = item.dataset.result !== winner; });
      result.querySelectorAll('[data-result-other]').forEach((item) => { item.hidden = item.dataset.resultOther === winner; });
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    quiz.querySelectorAll('[data-quiz-retake]').forEach((retakeBtn) => {
      retakeBtn.addEventListener('click', () => {
        quiz.querySelectorAll('input').forEach((input) => { input.checked = false; });
        step = 0;
        result.hidden = true;
        result.classList.remove('on');
        controls.hidden = false;
        shell?.classList.add('on');
        render();
        shell?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Exposed on the element itself (rather than kept purely in this
       closure) so the single document-level shopify:block:select listener
       below can jump to a question without holding its own reference to
       this quiz instance — that reference would otherwise go stale every
       time the Theme Editor reloads this section into a fresh DOM node. */
    quiz._quizApi = {
      goToStep: (index) => {
        if (index < 0 || index >= questions.length) return;
        step = index;
        if (hero) hero.style.display = 'none';
        shell?.classList.add('on');
        render();
      }
    };

    render();
  };

  const init = (root) => {
    if (root.matches?.('[data-scent-quiz]')) initQuiz(root);
    root.querySelectorAll?.('[data-scent-quiz]').forEach(initQuiz);
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  /* An "Answer" block's shopify_attributes sit on its .vopt/.topt label,
     which lives inside the [data-quiz-question] step it belongs to — only
     one step is visible at a time, so selecting a block for a different
     question needs to switch steps before that block is visible to edit. */
  document.addEventListener('shopify:block:select', (event) => {
    const question = event.target.closest?.('[data-quiz-question]');
    const quiz = question?.closest('[data-scent-quiz]');
    if (!question || !quiz?._quizApi) return;
    const index = [...quiz.querySelectorAll('[data-quiz-question]')].indexOf(question);
    quiz._quizApi.goToStep(index);
    question.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
